<template>
  <v-btn text small v-if="selected" class="tw-bg-gray-400 tw-font-bold tw-cursor-not-allowed">
    <span class="mr-1">
      <v-icon :color="openColor" small>{{ icon }}</v-icon>
    </span>
    <span style="color: var(--v-primary-base)">{{ $t(`${menu}.${name}.menu_name`) }}</span>
  </v-btn>
  <v-btn text small v-else :title="$t(`${menu}.${name}.title`)" @click="openPage">
    <span class="mr-1">
      <v-icon :color="openColor" small>{{ icon }}</v-icon>
    </span>
    <span> {{ $t(`${menu}.${name}.menu_name`) }}</span>
  </v-btn>
</template>

<script>
export default {
  name: "TabToolbarButton",
  props: {
    menu: { type: String, required: true },
    name: { type: String, required: true },
    value: { type: String, required: true },
    icon: { type: String, required: true },
    selected: { type: Boolean, required: false, default: false },
  },
  mounted() {
    const alreadyOpened = this.$ls.get(`tab.${this.menu}`)
    if (alreadyOpened === this.name) {
      this.$emit("input", this.name)
      this.$emit("click")
    }
  },
  computed: {
    openColor() {
      return this.value === this.name ? "primary" : ""
    },
  },
  methods: {
    openPage() {
      this.$emit("input", this.name)
      this.$emit("click")
      this.$ls.set(`tab.${this.menu}`, this.name)
    },
  },
}
</script>
